import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const getListByShared = ({
                                cityID = -1,
                                streetID = -1,
                                gush = '',
                                helka = '',
                                fromDate = '',
                                toDate = '',
                                requestedPageNumber = 0,
                              }) => dispatch => {
  dispatch({
    type: A.GET_INSPECTIONS_BY_SHARED_LIST
  });

  const data = {
    cityID,
    streetID,
    gush,
    helka,
    fromDate,
    toDate,
    requestedPageNumber
  };

  return axios.post(api.GET_LIST_BY_SHARED, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {inspections, statistics, totalPageCount, currentPageNumber, totalResultCount} = body;

      dispatch({
        type: A.GET_INSPECTIONS_BY_SHARED_LIST_SUCCESS,
        payload: {list: inspections, statistics: statistics, totalPages: totalPageCount, totalResultCount},
      });
      dispatch({
        type: A.SET_INSPECTIONS_BY_SHARED_PAGE,
        payload: {page: currentPageNumber}
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_INSPECTIONS_BY_SHARED_LIST_FAILURE,
        payload: err.message
      })
    });
};
